export default [
  {
    img: 'jpm-editions.png',
    title: 'JPM Editions',
    activity: 'Communication agency',
    link: 'http://www.pmechin.com/',
    desc:
      'JPM Editions is a communication agency based in France offering a wide range of services from print to web design. I have worked with them on several web projects, building static responsive webpages.',
    specs: [
      '8 responsive templates to build',
      '1 slider',
      '1 carousel',
      '1 jQuery tab',
    ],
    tags: ['RWD', 'HTML5', 'jQuery', 'CMS', 'SASS'],
  },
  {
    img: 'nougier.png',
    title: 'Nougier Hotel Restaurant',
    activity: 'French hotel and restaurant',
    link: 'https://www.hotelnougier.fr/',
    desc:
      'Nougier is a 3-star hotel restaurant based in France. Modernity, charm, confort were some of the few keywords for the re-skin of their website.',
    specs: [
      '9 responsive templates to build',
      '1 slider',
      '1 carousel',
      '1 jQuery tab',
      '1 lightbox',
    ],
    tags: ['RWD', 'HTML5', 'jQuery', 'CMS', 'SASS'],
  },
  {
    img: 'htmlene.png',
    title: 'Htmlene',
    activity: 'Me, myself and I',
    link: 'htmlene.co.uk/1.0',
    desc:
      'Previous version of my website, done 3 years ago, before I moved to the UK.',
    specs: ['One-page template', '1 pie chart'],
    tags: ['RWD', 'UX', 'Flat Design', 'HTML5', 'CSS3', 'jQuery', 'LESS'],
  },
  {
    img: 'lyon-ethique.png',
    title: 'Lyon Ethique',
    activity: 'Non-profit organization',
    link: 'http://www.lyon-ethique.org/',
    desc:
      'The Lyonnaise Association of Economic and Social Ethics aims to improve reflection and knowledge on ethical issues by raising awareness and education.',
    specs: ['7 templates to build', '1 slider', '1 newsletter'],
    tags: ['HTML5', 'CSS3', 'jQuery', 'LESS', 'CMS'],
  },
  {
    img: 'aflar.png',
    title: 'AFLAR',
    activity: 'Non-profit organization',
    link: 'http://www.aflar.org/',
    desc:
      'The French Association of Rheumatic is an association dedicated to all osteo-articular disorders.',
    specs: ['15 templates to build', '1 slider', '1 jQuery tab'],
    tags: ['XHTML', 'CSS2', 'jQuery', 'LESS', 'CMS'],
  },
  {
    img: 'andar.png',
    title: 'ANDAR',
    activity: 'Non-profit organization',
    link: 'http://www.polyarthrite-andar.com/',
    desc:
      'ANDAR provides information about Rheumatoid Arthritis and its consequences for people.',
    specs: ['11 templates to build', '1 slider', '1 newsletter'],
    tags: ['XHTML', 'CSS2', 'jQuery', 'CMS'],
  },
  {
    img: 'essarts.png',
    title: 'La Maison des Essarts',
    activity: 'Community Center',
    link: 'http://www.maisondesessarts.fr/',
    desc:
      'La Maison des Essarts is a social/community website that organises social events for citizens.',
    specs: ['8 templates to build', '1 slider', '1 carousel', '1 jQuery tab'],
    tags: ['XHTML', 'CSS2', 'jQuery'],
  },
];
